var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M1026,4580a49.842,49.842,0,1,1,19.463-3.929A49.68,49.68,0,0,1,1026,4580Zm-.5-65a10.512,10.512,0,0,0-10.5,10.5c0,4.067,2.855,9.153,5.25,12.7a68.1,68.1,0,0,0,5.25,6.8,68.494,68.494,0,0,0,5.25-6.8c2.4-3.55,5.25-8.636,5.25-12.7A10.512,10.512,0,0,0,1025.5,4515Zm0,14.25a3.75,3.75,0,1,1,3.751-3.75A3.754,3.754,0,0,1,1025.5,4529.25Z",
    transform: "translate(-976 -4480)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocationIcon);
export default __webpack_public_path__ + "static/media/contact-location-icon.80ba69616027e5cb5a19b969f96fa20f.svg";
export { ForwardRef as ReactComponent };